import { QueryFunction } from '@libs/focus-frontend-api/src/reactQueryHooks/useQuery/types';
import { CompanyInfo } from '@libs/focus-frontend-types/src/@teamleader/api/companies';
import { ContactInfo } from '@libs/focus-frontend-types/src/@teamleader/api/contacts';
import { Entity, Sideloaded } from '@libs/focus-frontend-types/src/@teamleader/api/generics';
import { ProjectInfo } from '@libs/focus-frontend-types/src/@teamleader/api/nextgen/projects';
import { TaskInfo } from '@libs/focus-frontend-types/src/@teamleader/api/tasks';
import { TicketInfo } from '@libs/focus-frontend-types/src/@teamleader/api/tickets';

export const ENTITY_TO_HINT_MAP = {
  [Entity.Contact]: {
    set: (id: string) => window.TL.Context.setContactHint(id),
    get: () => window.TL.Context.getContactHint(),
    query: ({ id }) => ['contacts', 'info', { id }],
  },
  [Entity.Company]: {
    set: (id: string) => window.TL.Context.setCompanyHint(id),
    get: () => window.TL.Context.getCompanyHint(),
    query: ({ id }) => ['companies', 'info', { id }],
  },
  [Entity.NextgenProject]: {
    set: (id: string) => window.TL.Context.setProjectHint(id),
    get: () => window.TL.Context.getProjectHint(),
    query: ({ id }) => ['projects-v2/projects', 'info', { id, include: 'primary_customer,customers' }],
  },
  [Entity.Task]: {
    set: (id: string) => window.TL.Context.setTaskHint(id),
    get: () => window.TL.Context.getTaskHint(),
    query: ({ id }) => [
      'tasks',
      'info',
      { id, include: 'customer,project,milestone,work_type,group', includes: 'tracked_time' },
    ],
  },
  [Entity.Ticket]: {
    set: (id: string) => window.TL.Context.setTicketHint(id),
    get: () => window.TL.Context.getTicketHint(),
    query: ({ id }) => ['tickets', 'info', { id, include: 'customer' }],
  },
} satisfies Partial<
  Record<
    Entity,
    {
      set: (id: string) => void;
      get: () => string | number | undefined;
      query: QueryFunction<{ id: string }>;
    }
  >
>;

export interface HintTypeMap {
  [Entity.Contact]: ContactInfo;
  [Entity.Company]: CompanyInfo;
  [Entity.NextgenProject]: ProjectInfo;
  [Entity.Task]: TaskInfo;
  [Entity.Ticket]: Sideloaded<TicketInfo, 'customer'>;
}
